import React, { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchClients } from '../utils/helper';

import { useAuth } from './AuthContext';
interface ClientDataProviderProps {
  children: ReactNode;
}

export const ClientDataProvider: React.FC<ClientDataProviderProps> = ({ children }) => {

  const { jwt } = useAuth();
  
  // Fetch clients using useQuery to populate the cache
  useQuery({
    queryKey: ['clients'],
    queryFn: () => fetchClients(jwt),
    staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
    refetchOnWindowFocus: false, // Prevent refetch on window focus
    // enabled: !!user, // Uncomment and pass user prop if conditional fetching is needed
  });

  // Render only the children, no UI
  return <>{children}</>;
};